import { render, staticRenderFns } from "./AllEventTab.vue?vue&type=template&id=56a47b0b&lang=pug"
import script from "./AllEventTab.vue?vue&type=script&lang=ts"
export * from "./AllEventTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports